import { useEffect, useState } from "react";
import { api, saveSession, type User } from "../api";

/** Экран по ссылке-приглашению: сотрудник задаёт пароль сам. */
export default function Invite({ token, onDone }: { token: string; onDone: (u: User) => void }) {
  const [who, setWho] = useState<{ name: string; login: string } | null>(null);
  const [checking, setChecking] = useState(true);
  const [dead, setDead] = useState<string | null>(null);
  const [p1, setP1] = useState("");
  const [p2, setP2] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    void (async () => {
      try {
        setWho(await api<{ name: string; login: string }>(`/api/auth/invite/${encodeURIComponent(token)}`));
      } catch (e: any) {
        setDead(e?.status === 0 ? "Нет связи. Открой ссылку при интернете." : e?.message ?? "Ссылка недействительна");
      } finally {
        setChecking(false);
      }
    })();
  }, [token]);

  const tooShort = p1.length > 0 && p1.length < 8;
  const mismatch = p2.length > 0 && p1 !== p2;
  const canSubmit = p1.length >= 8 && p1 === p2 && !busy;

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true); setError(null);
    try {
      const res = await api<{ token: string; user: User }>(`/api/auth/invite/${encodeURIComponent(token)}`, {
        method: "POST", body: { password: p1 },
      });
      await saveSession(res.token, res.user);
      onDone(res.user);
    } catch (e: any) {
      setError(e?.message ?? "Не удалось задать пароль");
    } finally {
      setBusy(false);
    }
  }

  if (checking) {
    return <div className="app"><div className="body"><div className="empty">Проверяем ссылку…</div></div></div>;
  }

  if (dead) {
    return (
      <div className="app"><div className="body">
        <div className="center">
          <div className="logo" aria-hidden="true">L</div>
          <div className="err">{dead}</div>
          <div className="hint" style={{ textAlign: "center" }}>
            Ссылка живёт сутки и срабатывает один раз. Попроси новую у руководителя.
          </div>
        </div>
      </div></div>
    );
  }

  return (
    <div className="app">
      <div className="body">
        <form className="center" onSubmit={submit}>
          <div className="logo" aria-hidden="true">L</div>
          <div style={{ textAlign: "center", marginBottom: 22 }}>
            <div style={{ fontSize: 20, fontWeight: 660 }}>Здравствуйте, {who?.name}</div>
            <div className="hint" style={{ marginTop: 4 }}>
              Логин: <b>{who?.login}</b>. Придумайте пароль — его знаете только вы.
            </div>
          </div>

          {error && <div className="err">{error}</div>}

          <div className="field">
            <label className="label" htmlFor="p1">Пароль <span className="req">*</span></label>
            <input id="p1" className="inp" type="password" value={p1} autoComplete="new-password"
              onChange={(e) => setP1(e.target.value)} required />
            <div className="hint" style={tooShort ? { color: "var(--crit)" } : undefined}>
              Не короче 8 символов
            </div>
          </div>
          <div className="field">
            <label className="label" htmlFor="p2">Ещё раз <span className="req">*</span></label>
            <input id="p2" className="inp" type="password" value={p2} autoComplete="new-password"
              onChange={(e) => setP2(e.target.value)} required />
            {mismatch && <div className="hint" style={{ color: "var(--crit)" }}>Пароли не совпадают</div>}
          </div>

          <button className="btn primary wide" type="submit" disabled={!canSubmit}>
            {busy ? "Сохраняем…" : "Сохранить и войти"}
          </button>
        </form>
      </div>
    </div>
  );
}
